'use client';

import { IndicatorBadge } from '@arckit/daisyui/primitives';
import { Popover, Trigger } from '@arckit/daisyui/primitives-client';
import { useAppForm } from '@arckit/form';
import { endLoad, startLoad } from '@/libraries/map';
import { useQueryState, useRouter } from '@/libraries/nextjs/shim';
import { arraysEqual } from '@/libraries/utils/array';
import { noEmptyString } from '@/libraries/utils/string';
import { useTransitionWithCallback } from '@/libraries/utils/use-transition-with-callback';

const dispositifsOptions = [
  { label: 'Conseillers numériques', value: 'Conseillers numériques', id: 'conseillers-numeriques' },
  { label: 'France Services', value: 'France Services', id: 'france-services' }
];

export const DispositifsFilters = () => {
  const router = useRouter();
  const [, startTransition] = useTransitionWithCallback(endLoad);

  const [dispositifProgrammesNationaux, setDispositifProgrammesNationaux] = useQueryState('dispositif_programmes_nationaux', {
    defaultValue: ''
  });

  const defaultValues = {
    dispositifProgrammesNationaux: dispositifProgrammesNationaux.split(',').filter(noEmptyString)
  };

  const selectedFiltersCount = defaultValues.dispositifProgrammesNationaux.length;

  const form = useAppForm({
    defaultValues,
    onSubmit: async ({ value }) => {
      if (arraysEqual(defaultValues.dispositifProgrammesNationaux)(value.dispositifProgrammesNationaux)) return;

      startTransition(async () => {
        await setDispositifProgrammesNationaux(value.dispositifProgrammesNationaux.filter(noEmptyString).join(','));
        startLoad();
        router.refresh();
      });
    }
  });

  return (
    <IndicatorBadge
      displayIndicator={selectedFiltersCount > 0}
      indicatorContent={selectedFiltersCount}
      className='!rounded-full font-bold'
      color='badge-primary'
      scale='badge-xs'
    >
      <Popover
        trigger={<Trigger>Dispositifs</Trigger>}
        className='border-base-200 rounded'
        contentClassName='w-110 ring ring-base-100 mt-2'
        color='btn-primary'
        kind='btn-outline'
        onClose={form.handleSubmit}
      >
        <div className='p-8 flex flex-col gap-2'>
          <form.AppField name='dispositifProgrammesNationaux'>
            {(field) => <field.CheckboxGroup options={dispositifsOptions} isPending={false} />}
          </form.AppField>
        </div>
      </Popover>
    </IndicatorBadge>
  );
};
